import { Reveal } from "./Reveal";
import { KnowledgeGraphWidget } from "./KnowledgeGraphWidget";
import { useI18n } from "../i18n/LanguageContext";

export const KnowledgeGraphSection = () => {
  const { t } = useI18n();
  const points = t("graph.points");
  return (
    <section id="graph" className="relative py-28 md:py-36 px-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <div>
            <p className="font-mono text-[13px] tracking-[0.3em] uppercase text-[#4BE3FF] mb-5">
              {t("graph.kicker")}
            </p>
            <h2 className="font-display font-bold tracking-tight text-4xl md:text-5xl leading-[1.03]">
              {t("graph.titleA")}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#4BE3FF] to-[#1E6FFF]">
                {t("graph.titleB")}
              </span>
            </h2>
            <p className="font-ui text-[15px] md:text-base text-[#A7B4C2] mt-6 leading-relaxed max-w-lg">
              {t("graph.desc")}
            </p>
            <ul className="mt-8 space-y-3">
              {points.map((p) => (
                <li
                  key={p}
                  className="flex items-start gap-3 font-mono text-[13px] text-[#A7B4C2]"
                >
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#4BE3FF] shrink-0 cyan-glow" />
                  {p}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <KnowledgeGraphWidget />
        </Reveal>
      </div>
    </section>
  );
};
